import type { SVGProps } from 'react';

const PIN_BODY_D =
  'M9.88 7.78143L13.15 5.67143C13.2774 5.59418 13.3859 5.48945 13.4676 5.36489C13.5493 5.24034 13.6021 5.0991 13.6223 4.95151C13.6424 4.80391 13.6293 4.65368 13.5839 4.5118C13.5385 4.36991 13.462 4.23996 13.36 4.13143L10.15 0.921426C10.0415 0.819392 9.91151 0.742893 9.76963 0.697519C9.62775 0.652145 9.47752 0.639043 9.32992 0.65917C9.18232 0.679297 9.04109 0.732144 8.91653 0.81385C8.79198 0.895557 8.68725 1.00406 8.61 1.13143L6.45 4.36143L1.96 5.36143C1.85732 5.38634 1.76304 5.43793 1.6867 5.51097C1.61036 5.58401 1.55465 5.67592 1.52523 5.77739C1.4958 5.87887 1.49369 5.98632 1.51911 6.08887C1.54453 6.19142 1.59658 6.28544 1.67 6.36143L7.82 12.5214C7.89785 12.5919 7.99256 12.641 8.09497 12.6642C8.19739 12.6873 8.30403 12.6836 8.4046 12.6534C8.50516 12.6232 8.59623 12.5676 8.66901 12.492C8.74178 12.4163 8.79379 12.3231 8.82 12.2214L9.88 7.78143Z';

const PIN_TAIL_D = 'M4.74 9.51143L0.65 13.6314';

export function PinActionIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 14.2814 14.2814"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.3}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d={PIN_BODY_D} />
      <path d={PIN_TAIL_D} />
    </svg>
  );
}
